import { serializable, alias, primitive } from 'serializr';

export class BuildingId {
	@serializable(alias('id', primitive()))
	id?: number;

	@serializable(alias('name', primitive()))
	name?: string;
}
